import { render, staticRenderFns } from "./survey-step-triglyceride-management.vue?vue&type=template&id=516751fe"
import script from "./survey-step-triglyceride-management.vue?vue&type=script&lang=js"
export * from "./survey-step-triglyceride-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports